/**
 * Утилиты для валидации промокодов
 * Чистые функции без зависимостей от Vue
 */

/**
 * Проверяет формат промокода
 * @param {String} promoCode - промокод для проверки
 * @returns {Object} { isValid: boolean, error: string }
 */
export function validatePromoCode(promoCode) {
  if (!promoCode) {
    return { isValid: true, error: '' }; // Пустой промокод - не ошибка, просто не заполнен
  }

  // Проверка длины (6-10 символов)
  if (promoCode.length < 6 || promoCode.length > 10) {
    return {
      isValid: false,
      error: 'promo-length-error', // Ключ для i18n
    };
  }

  // Проверка на русские буквы и спецсимволы
  const regex = /[а-яА-ЯёЁ\W]+/;
  if (regex.test(promoCode)) {
    return {
      isValid: false,
      error: 'promo-value-error', // Ключ для i18n
    };
  }

  return { isValid: true, error: '' };
}
